import * as routes from '@/router/route-names'

// Must match java side, SideMenuOption
const options = Object.freeze({
  ACCOUNT: 'Account',
  ATTORNEYS: 'Attorneys',
  BILLING_HISTORY: 'BillingHistory',
  BUILDERS_RISK: 'BuildersRisk',
  CLAIMS: 'Claims',
  COI_REQUEST: 'CertificateRequest',
  COMMUNICATIONS: 'Communications',
  DATA_REQUEST: 'DataRequest',
  DIRECT_SCHEDULES: 'DirectSchedules',
  DOCUMENTS: 'Documents',
  GENERAL_INFO: 'GeneralInfo',
  NEW_BIZ_LINK: 'NewBusinessLink',
  POLICY_ADMIN: 'PolicyAdmin',
  RENEWAL_DASHBOARD: 'RenewalDashboard',
  RISK_MANAGEMENT: 'RiskManagement',
  UPDATE_FIRM: 'UpdateFirm',
})

const sideMenuItems = {
  [options.ACCOUNT]: {
    type: options.ACCOUNT,
    title: 'Account',
    componentIcon: 'AccountIcon',
    routeName: routes.ACCOUNT,
  },
  [options.ATTORNEYS]: {
    type: options.ATTORNEYS,
    title: 'Attorneys',
    componentIcon: 'AttorneysIcon',
    routeName: routes.ATTORNEYS,
  },
  [options.GENERAL_INFO]: {
    type: options.GENERAL_INFO,
    title: 'General Info',
    icon: 'mdi-information',
    routeName: routes.PROFILE_GENERAL,
    sideMenuOnly: true,
  },
  [options.COMMUNICATIONS]: {
    type: options.COMMUNICATIONS,
    title: 'Communications',
    componentIcon: 'CommunicationsIcon',
    routeName: routes.COMMUNICATIONS,
  },
  // FYI: This title specifically is dynamically named by a feature
  [options.RENEWAL_DASHBOARD]: {
    type: options.RENEWAL_DASHBOARD,
    title: '',
    componentIcon: 'RenewalDashboardIcon',
    routeName: routes.RENEWAL_DASHBOARD,
  },
  [options.POLICY_ADMIN]: {
    type: options.POLICY_ADMIN,
    id: 'side-menu-policy-admin',
    title: 'Policy Admin',
    componentIcon: 'PolicyAdminIcon',
    routeName: routes.POLICY_ADMIN,
    clientOnly: true,
  },
  [options.RISK_MANAGEMENT]: {
    type: options.RISK_MANAGEMENT,
    id: 'side-menu-risk-management',
    title: 'Risk Management',
    componentIcon: 'RiskManagementIcon',
    routeName: routes.DASHBOARD_RISK_MANAGEMENT,
  },
  [options.DOCUMENTS]: {
    type: options.DOCUMENTS,
    id: 'side-menu-documents',
    title: 'Documents',
    icon: 'mdi-file-multiple',
    routeName: routes.DOCUMENTS,
    sideMenuOnly: true,
  },
  [options.NEW_BIZ_LINK]: {
    type: options.NEW_BIZ_LINK,
    title: 'New Business',
    icon: 'mdi-handshake',
    routeName: routes.INSURICA_NEW_BUSINESS_FLOW,
    sideMenuOnly: true,
  },
  [options.DIRECT_SCHEDULES]: {
    type: options.DIRECT_SCHEDULES,
    title: 'Schedules',
    componentIcon: 'SchedulesIcon',
    routeName: routes.SCHEDULES,
  },
  [options.BUILDERS_RISK]: {
    type: options.BUILDERS_RISK,
    id: 'side-menu-builders-risk',
    title: 'Builders Risk',
    componentIcon: 'BuildersRiskIcon',
    routeName: routes.BUILDERS_RISK_PROJECTS,
  },
  [options.DATA_REQUEST]: {
    type: options.DATA_REQUEST,
    title: 'Data Request',
    icon: 'mdi-format-list-bulleted',
    routeName: routes.DATA_REQUEST_SELECTOR,
    sideMenuOnly: true,
  },
  [options.CLAIMS]: {
    type: options.CLAIMS,
    title: 'Claims',
    componentIcon: 'ClaimsIcon',
    routeName: routes.CREATE_CLAIM_PORTAL,
    clientOnly: true,
  },
  [options.COI_REQUEST]: {
    type: options.COI_REQUEST,
    title: 'Certificate Request',
    componentIcon: 'CertificateRequestIcon',
    routeName: routes.CERT_OF_INSURANCE_REQUEST,
    clientOnly: true,
  },
  [options.BILLING_HISTORY]: {
    type: options.BILLING_HISTORY,
    title: 'Billing History',
    componentIcon: 'BillingHistoryIcon',
    routeName: routes.BILLING_HISTORY,
    clientOnly: true,
  },
  [options.UPDATE_FIRM]: {
    type: options.UPDATE_FIRM,
    title: 'Update Firm',
    componentIcon: 'UpdateFirmIcon',
    routeName: routes.UPDATE_FIRM,
    clientOnly: true,
  },
}

const defaultOptions = [options.ACCOUNT, options.RENEWAL_DASHBOARD, options.COMMUNICATIONS, options.POLICY_ADMIN, options.RISK_MANAGEMENT]

export { options, defaultOptions, sideMenuItems }
